import ApiService from './ApiService';

export default class LibraryApi extends ApiService {
    getAllFile(payload) {
        return this.get('file-in-lib', payload);
    }

    deleteFile(payload) {
        return this.delete('file-in-lib', payload);
    }

    uploadFile(payload) {
        return this.post('file-in-lib', payload, { headers: { 'Content-Type': 'multipart/form-data' } });
    }
}
